<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                基站导入
                <small>基站导入</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 基站导入
                    </a>
                </li>
                <li class="active">基站导入</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <!-- Main row -->
            <div class="row col-sm-12 station_import_content">
                <select class="chosen-select-layer" name id v-model="layerid">
                    <option value>请选择图层</option>
                    <option v-for="(item,index) in layerlist" :key="index" :value="item.id">{{item.name}}</option>
                </select>

                <div class="station_import_title">
                    {{uploadExcelText}}
                    <input
                            type="file"
                            @change="uploadExcel"
                            class="uploadExcel"
                            accept=".xls, .xlsx"
                    />
                </div>
                <a
                        class="downloadFile"
                        href="https://jtzn.oss-cn-beijing.aliyuncs.com/2019-09-02/station_import_template.xlsx"
                >点击下载模板</a>
            </div>
        </section>
    </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        uploadExcelText: '导入基站',
        layerlist: [],
        layerid: '' // 被选中的图层
      }
    },
    components: {},
    mounted: function () {
      var self = this
      // 获取所有的图层
      var companyId = JSON.parse(localStorage.getItem('companyInfo')).id
      self.global.axiosGet(
        self,
        'organization/' + companyId + '/layers/',
        function (e) {
          console.log('获取图层信息---', e)
          self.layerlist = e
          setTimeout(function () {
            $('.chosen-select-layer').trigger('chosen:updated')
          }, 1000)
        }
      )

      // 选择图层
      $('.chosen-select-layer')
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: '200px'
        })
        .change(function () {
          self.layerid = $('.chosen-select-layer').val()
        })
    },
    methods: {
      uploadExcel: function (e) {
        console.log(e)
        var self = this
        if (self.layerid == '') {
          alert('请先选择图层')
          return
        }
        var formData = new FormData()
        var files = []
        var file = $('.uploadExcel')[0].files[0]
        files.push(file)
        if (files.length < 1) {
          formData.append('file', new Blob())
        } else {
          formData.append('file', file)
        }
        formData.append('layer_id', self.layerid)
        self.uploadExcelText = '正在导入,请稍后...'
        self.global.axiosPost(
          self,
          'station_import/',
          formData,
          function (res) {
            console.log(res)
            if (res.status == 'success') {
              alert('操作成功!')
            } else {
              alert('操作失败,请稍后刷新重试')
            }
            self.uploadExcelText = '导入基站'
          },
          function (res) {
            console.log(res)
            alert('操作失败')
            self.uploadExcelText = '导入基站'
          }
        )
      }
    }
  }
</script>
<style scoped>
    .station_import_content {
        background: #fff;
        height: 88vh;
    }

    .station_import_title {
        background: #3c8dbc;
        line-height: 60px;
        text-align: center;
        margin: 200px auto 0;
        width: 310px;
        border-radius: 8px;
        font-size: 27px;
        color: #fff;
        position: relative;
    }

    .uploadExcel {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .downloadFile {
        text-align: center;
        margin: 20px auto;
        display: inherit;
    }
</style>



// WEBPACK FOOTER //
// src/views/stationImport/stationImport.vue